import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/copy';
export function TestimonialsSection() {
  return <section className="w-full bg-slate-950 py-10 [contain-intrinsic-size:auto_900px] [content-visibility:auto] sm:py-14 [.chalk_&]:bg-slate-50" aria-labelledby="testimonials-heading" data-id="element-222" data-mp="1n0ae5ipn6ux5">
      <div className="mx-auto max-w-4xl px-6" data-id="element-223" data-mp="1d1unthyfvpop">
        <SectionHeading title={<span id="testimonials-heading" data-id="element-225" data-mp="1d0jivet9cbw0">What youth coaches are looking for</span>} data-id="element-224" data-mp="1d133526drcd7" />

        <ul className="mt-10 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-226" data-mp="1i2ioywgdtmwn">
          {testimonials.map((testimonial, index) => <li key={`${testimonial.role}-${index}`} className="flex flex-col rounded-3xl border border-slate-800 bg-slate-900 p-6 sm:p-7 [.chalk_&]:border-slate-200 [.chalk_&]:bg-white" data-id="element-227" data-mp="142zh84rhgdkv" data-mpi={index}>
              <QuoteIcon className="h-7 w-7 shrink-0 text-orange-400 [.chalk_&]:text-orange-600" strokeWidth={1.8} aria-hidden="true" data-id="element-228" data-mp="2yfpbinlrjoss" />
              <blockquote className="mt-4 text-lg leading-relaxed text-slate-50 [.chalk_&]:text-slate-900" data-id="element-229" data-mp="32egbd2hm5kjl">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto pt-6" data-id="element-230" data-mp="2q27t9674pedc">
                <p className="border-t border-slate-800 pt-5 text-base font-bold uppercase tracking-wide text-slate-50 [.chalk_&]:border-slate-200 [.chalk_&]:text-slate-900" data-id="element-231" data-mp="34r48bn7lrrng">
                  {testimonial.role}
                </p>
                <p className="mt-0.5 text-sm text-slate-400 [.chalk_&]:text-slate-600" data-id="element-232" data-mp="2c3hwxss4viq1">{testimonial.country}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}